import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import { FaTimes } from "react-icons/fa";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();
  const freeShippingThreshold = 200; // Example threshold
  const remainingForFreeShipping = Math.max(
    0,
    freeShippingThreshold - subtotal
  );
  const progressPercentage = Math.min(
    100,
    (subtotal / freeShippingThreshold) * 100
  );

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page empty">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/" onClick={toTop}>
              Home
            </Link>
            <span className="separator">|</span>
            <span className="current">Your cart</span>
          </nav>
          <div className="empty-message">
            <h2>Your cart is empty</h2>
            <Link to="/shop" className="btn-continue" onClick={toTop}>
              Continue Shopping
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="container">
        <nav className="breadcrumb">
          <Link to="/" onClick={toTop}>
            Home
          </Link>
          <span className="separator">|</span>
          <span className="current">Your cart</span>
        </nav>

        <h1 className="page-title">Your cart ({cartItems.length})</h1>

        <div className="cart-content">
          <div className="cart-items">
            {cartItems.map((item) => {
              const product = getProductById(item.id);
              if (!product) return null;
              return (
                <div
                  key={`${item.id}-${item.size}-${item.color}`}
                  className="cart-item"
                >
                  <button
                    className="remove-btn"
                    onClick={() =>
                      removeFromCart(item.id, item.size, item.color)
                    }
                  >
                    <FaTimes />
                  </button>
                  <div className="item-image">
                    <img src={product.image} alt={product.name} />
                  </div>
                  <div className="item-info">
                    <h3 className="item-name">{product.name}</h3>
                    {item.size && <p className="item-variant">{item.size}</p>}
                    {item.color && <p className="item-variant">{item.color}</p>}
                    <p className="item-price-unit">${product.price}</p>
                  </div>
                  <div className="item-actions">
                    <div className="quantity-selector">
                      <button
                        onClick={() =>
                          handleUpdateQuantity(
                            item.id,
                            item.size,
                            item.color,
                            item.quantity - 1
                          )
                        }
                      >
                        -
                      </button>
                      <span>{item.quantity}</span>
                      <button
                        onClick={() =>
                          handleUpdateQuantity(
                            item.id,
                            item.size,
                            item.color,
                            item.quantity + 1
                          )
                        }
                      >
                        +
                      </button>
                    </div>
                    <div className="item-total">
                      ${(parseFloat(product.price) * item.quantity).toFixed(2)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <aside className="cart-summary">
            <div className="shipping-progress">
              <p className="shipping-msg">
                {remainingForFreeShipping > 0
                  ? `Spend $${remainingForFreeShipping.toFixed(
                      2
                    )} more to reach free shipping!`
                  : "You've reached free shipping!"}
              </p>
              <div className="progress-bar">
                <div
                  className="progress-fill"
                  style={{ width: `${progressPercentage}%` }}
                ></div>
              </div>
            </div>

            <div className="summary-footer">
              <div className="total-row">
                <span>Estimated total</span>
                <span className="total-amount">${subtotal.toFixed(2)} SGD</span>
              </div>
              <p className="tax-info">
                Tax included and shipping calculated at checkout
              </p>
              <button className="checkout-btn" onClick={handleCheckout}>
                Check Out
              </button>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
